import { AuthorWorkParent } from './AuthorWork'
import { BibliographyParent } from './directories/Bibliography'
import { List } from './List'
import { Employee } from './directories/Employee'

export class CommonWorkParent extends List {
  constructor(obj) {
    super(CommonWork, obj)
  }
}

export class CommonWork {
  constructor(obj = {}) {
    this.isEffContract = obj?.isEffContract ?? false
    this.id = obj?.id || null
    this.workName = obj?.workName || null
    this.workType = obj?.workType || null
    this.workId = obj?.workId || null
    this.statementDate = obj?.statementDate || null
    this.period = obj?.period || null
    this.status = obj?.status || null
    this.year = obj?.year || null
    this.creator = new Employee(obj?.creator || null)
    this.comment = obj?.comment || null
    this.authors = new AuthorWorkParent(obj?.authors || null)
    this.bibliographies = new BibliographyParent(obj?.bibliographies || null)
    this.link = obj?.link || null
    this.departments = obj?.departments || []
    this.scientDepartments = obj?.scientDepartments || []
  }

  setStatusToDraft() {
    this.status = { id: 1, name: 'Черновик' }
  }

  setStatusToReview() {
    this.status = { id: 2, name: 'Отправить на рассмотрение' }
  }

  setStatusToAccepted() {
    this.status = { id: 3, name: 'Принят' }
  }

  setStatusToRework() {
    this.status = { id: 4, name: 'Отправить на доработку' }
  }

  setStatusToReject() {
    this.status = { id: 5, name: 'Отклонить' }
  }

  getForAPI() {
    return {
      isEffContract: this.isEffContract,
      id: this.id,
      workName: this.workName,
      workType: this.workType,
      workId: this.workId,
      statementDate: this.statementDate,
      period: this.period,
      status: this.status,
      year: this.year,
      creator: this.creator.getForAPI(),
      comment: this.comment,
      authors: this.authors.getForAPI(),
      bibliographies: this.bibliographies.getForAPI(),
      link: this.link,
      departments: this.departments,
      scientDepartments: this.scientDepartments
    }
  }
}
